import Home from './Pages/Home'
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from './Component/Header'
import Footer from './Component/Footer'
import News from './Pages/news'
import Events from './Pages/events'
import Gallery from './Pages/gallery'
import SubGallery from './Pages/subGallery'
import TopperX from './Pages/topperX'
import TopperXII from './Pages/topperXII'
import PrincipalDesk from './Pages/principal';
import Director from './Pages/director';
import About from './Pages/about';
import Administration from './Pages/administration';
import AimsObjectives from './Pages/aimsObjectives';
import Visionmission from './Pages/visionmission';
import Management from './Pages/management';
import Patrons from './Pages/patrons';
import MsgDesk from './Pages/msgDesk';
import OurPrincipal from './Pages/ourPrincipal';
import Faculties from './Pages/faculties';
import AffiliationCourse from './Pages/affiliationCourse';
import MediumInstruction from './Pages/mediumInstruction';
import ComputerEducation from './Pages/computerEducation';
import SchoolTiming from './Pages/schoolTiming';
import Uniform from './Pages/uniform';
import Registration from './Pages/registration';
import Admission from './Pages/admission';
import AdmissionRequirement from './Pages/admissionRequirement';
import Withdrawal from './Pages/withdrawal';
import ExaminationPromotion from './Pages/examinationPromotion';
import Fees from './Pages/fees';
import Library from './Pages/library';
import GeneralRules from './Pages/generalRules';
import CoCuricularActivity from './Pages/coCuricularActivity';
import Sports from './Pages/sports';
import Celebrations from './Pages/celebrations';
import SpecialEvents from './Pages/specialEvents';
import ManifoldOpportunities from './Pages/manifoldOpportunities';
import UniqueIdentity from './Pages/uniqueIdentity';
import VideoGallery from './Pages/videoGallery';
import Contact from './Pages/contact';
import Tc from './Pages/Tc';
import ERPSoftware from './Pages/ERPSoftware';
import ParentPortal from './Pages/parentPortal';
 import Calendar from './Pages/calendar';
function App() {
  return (
    <>
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/News" element={<News />} />
          <Route path="/Events" element={<Events />} />
          <Route path="/Gallery" element={<Gallery />} />
          <Route path="/SubGallery" element={<SubGallery />} />
          <Route path="/TopperX" element={<TopperX />} />
          <Route path="/TopperXII" element={<TopperXII />} />
          <Route path="/principal" element={<PrincipalDesk />} />
          <Route path="/About" element={<About />} />
          <Route path="/Administration" element={<Administration />} />
          <Route path="/AimsObjectives" element={<AimsObjectives />} />
          <Route path="/Visionmission" element={<Visionmission />} />
          <Route path="/Management" element={<Management />} />
          <Route path="/Patrons" element={<Patrons />} />
          <Route path="/MsgDesk" element={<MsgDesk />} />
          <Route path="/OurPrincipal" element={<OurPrincipal />} />
          <Route path="/Faculties" element={<Faculties />} />
          <Route path="/AffiliationCourse" element={<AffiliationCourse />} />
          <Route path="/MediumInstruction" element={<MediumInstruction />} />
          <Route path="/ComputerEducation" element={<ComputerEducation />} />
          <Route path="/SchoolTiming" element={<SchoolTiming />} />
          <Route path="/Uniform" element={<Uniform />} />
          <Route path="/Registration" element={<Registration />} />
          <Route path="/Admission" element={<Admission />} />
          <Route path="/AdmissionRequirement" element={<AdmissionRequirement />} />
          <Route path="/Withdrawal" element={<Withdrawal />} />
          <Route path="/ExaminationPromotion" element={<ExaminationPromotion />} />
          <Route path="/Fees" element={<Fees />} />
          <Route path="/Library" element={<Library />} />
          <Route path="/GeneralRules" element={<GeneralRules />} />
          <Route path="/CoCuricularActivity" element={<CoCuricularActivity />} />
          <Route path="/Sports" element={<Sports />} />
          <Route path="/Celebrations" element={<Celebrations />} />
          <Route path="/SpecialEvents" element={<SpecialEvents />} />
          <Route path="/ManifoldOpportunities" element={<ManifoldOpportunities />} />
          <Route path="/UniqueIdentity" element={<UniqueIdentity />} />
          <Route path="/VideoGallery" element={<VideoGallery />} />
          <Route path="/Contact" element={<Contact />} />
          <Route path="/Director" element={<Director />} />
          <Route path="/Tc" element={<Tc />} />
          <Route path="/ERPSoftware" element={<ERPSoftware />} />
          <Route path="/ParentPortal" element={<ParentPortal />} />
          <Route path="/Calendar" element={<Calendar />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </>
  )
}

export default App;
